import { render, staticRenderFns } from "./submitForReviewDetail.vue?vue&type=template&id=fe90d6b6"
import script from "./submitForReviewDetail.vue?vue&type=script&lang=js"
export * from "./submitForReviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports